<template>
    <div id="benefit-level-filter">
      <FilterExpandCollapse :label="headerText" expand v-if="show">
        <div v-if="benefitLevels">
          <div class="header-container">
            <hp5-heading class="benefit-level-heading" :key="plan.tierLabel" size-selection="xs" tag-selection="p">{{ plan.tierLabel }}</hp5-heading>
            <hp5-popover popover-id="benefit-level-popover" :key="tooltipText" position-selection="bottom" icon-ally-label="More info">
            {{ tooltipText }}
            </hp5-popover>
          </div>
          <div>
            <hp5-semantic size-selection="xs">
              <input id="benefit-level-all" type="radio" name="benefit-level" value="" v-model="filterContext.tier" /><label for="benefit-level-all">All</label>
            </hp5-semantic>
          </div>
          <div v-for="level in benefitLevels" :key="level">
            <hp5-semantic size-selection="xs">
              <input :id="`benefit-level-${level}`" type="radio" name="benefit-level" :value="level" v-model="filterContext.tier" />
              <label :for="`benefit-level-${level}`">{{ label(level) }}</label>
            </hp5-semantic>
          </div>
        </div>
      </FilterExpandCollapse>
    </div>
</template>
  
<script setup>

    const model = useFCPModel()
    const { benefitLevelLabel } = useFilters(model)
    const { filterContext, plan } = model
    const headerText = computed(() => plan.value.tierLabel)
    const tooltipText = computed(() => {
        return `Your plan places providers into ${plan.value.tierLabel}s. ${plan.value.tierLabel} 1 will cost you the least.`
    })

    //Determine whether or not the component should be shown.  It should be shown if the plan is
    //tiered and there are benefit levels. 
    const show = computed(() => plan.value.isTiered && plan.value.tierCount > 1)

    //Compute and return the benefit level collection.
    const benefitLevels = computed(() => {
        if (!plan.value.isTiered) return []
        //Returns a list of levels.  For exaple if tierCount is 2, will return [0,1,2]
        const levels = Array.from(Array(plan.value.tierCount + 1).keys())
        //Shift the array to the left, removing element 0.
        levels.shift()

        return levels
    })

    //Calculate the label to display for a benefit level.
    const label = (level) => benefitLevelLabel(level)
  
</script>
  
<style scoped lang="scss">
  label {
    padding-left: var(--spacing-xs);
  }
  
  hp5-icon {
    fill: var(--color-link-base);
  }
  
  hp5-heading.benefit-level-heading {
    display: inline-block;
  }
  
  .tooltip-container {
    z-index: 1000;
  }
  
  .header-container {
    display: flex;
    align-items: center;
  }
</style>